export class ImportarTransportistaDTO {

    numero: number;
    // Properties mapped from Excel columns
    docIdentificacion: string;
    nombre: string;
    apellido: string;
    licencia: string;
    empresaTransporte: string;
    estado: string;
    errores: string;

    // Validation flags mapping for UI badge coloring
    docIdentificacionValido: boolean = true;
    nombreValido: boolean = true;
    apellidoValido: boolean = true;
    licenciaValido: boolean = true;
    empresaTransporteValido: boolean = true;
    estadoValido: boolean = true;

    // Error messages mapped from backend validation
    mensajeErrorDocIdentificacion: string;
    mensajeErrorNombre: string;
    mensajeErrorApellido: string;
    mensajeErrorLicencia: string;
    mensajeErrorEmpresaTransporte: string;
    mensajeErrorEstado: string;

    // General Validation 
    valido: boolean = true;

    constructor() { }

    copiar(item: any) {
        // Assign explicitly to bridge the backend's new keys to the DTO keys expected by the HTML
        this.numero = item.numero;
        this.docIdentificacion = item.traDocumento || item.docIdentificacion;
        this.nombre = item.traNombre || item.nombre;
        this.apellido = item.traApellido || item.apellido;
        this.licencia = item.traLicencia || item.licencia;
        this.empresaTransporte = item.codigoEmpresaTransporte || item.empresaTransporte;
        this.estado = item.estado;

        // Map validation booleans and errors with strengthened logic
        this.valido = item.valid !== undefined ? item.valid : item.valido;

        this.docIdentificacionValido = (item.traDocumentoValido !== undefined ? item.traDocumentoValido : true)
            && !item.documentoDuplicado && !item.documentoExistente;

        this.nombreValido = item.traNombreValido !== undefined ? item.traNombreValido : item.nombreValido;
        this.apellidoValido = item.traApellidoValido !== undefined ? item.traApellidoValido : item.apellidoValido;

        this.licenciaValido = (item.traLicenciaValido !== undefined ? item.traLicenciaValido : true)
            && !item.traLicenciaDuplicada && !item.traLicenciaExistente && !item.traLicenciaEnCompania;

        this.empresaTransporteValido = (item.empresaTransporteValido !== undefined ? item.empresaTransporteValido : true)
            && !item.empresaTransporteNoExistente;

        this.estadoValido = item.estadoValido !== undefined ? item.estadoValido : true;

        this.mensajeErrorDocIdentificacion = item.mensajeErrorTraDocumento || item.mensajeErrorDocIdentificacion;
        this.mensajeErrorNombre = item.mensajeErrorTraNombre || item.mensajeErrorNombre;
        this.mensajeErrorApellido = item.mensajeErrorTraApellido || item.mensajeErrorApellido;
        this.mensajeErrorLicencia = item.mensajeErrorTraLicencia || item.mensajeErrorLicencia;
        this.mensajeErrorEmpresaTransporte = item.mensajeErrorEmpresaTransporte;
        this.mensajeErrorEstado = item.mensajeErrorEstado;
        this.errores = item.errores;
    }

    cellStyle(valido: boolean): string {
        if (!valido) {
            return "red-bg";
        }
        return "";
    }
}
